/* eslint-disable */
//tslint:disable
export var ESenderType;

(function (ESenderType) {
  ESenderType["Sms"] = "sms";
  ESenderType["Call"] = "call";
})(ESenderType || (ESenderType = {}));

export var EType;

(function (EType) {
  EType["PhoneNumber"] = "phoneNumber";
  EType["ChangePassword"] = "changePassword";
  EType["ChangeEmail"] = "changeEmail";
  EType["ChangeCredit"] = "changeCredit";
  EType["BookingAnnouncement"] = "bookingAnnouncement";
  EType["AuthenticateCode"] = "authenticateCode";
})(EType || (EType = {}));